"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listPhonesRegions = listPhonesRegions;
exports.resourcesWatcher = resourcesWatcher;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _variables = require("../variables");
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _helpers = require("@qwkin/helpers");
var _variables2 = require("../../Notification/variables");
var _utils = require("../../../utils");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(resourcesWatcher);
function listPhonesRegions(_ref) {
  var _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? _helpers.identity : _ref$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response$data, _response$data2, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.ResourceService.listPhonesRegions);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables.LOAD_PHONE_REGIONS_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context.next = 17;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 14;
          return (0, _effects.put)({
            type: _variables.LOAD_PHONE_REGIONS_FAIL,
            payload: _response
          });
        case 14:
          _context.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 16:
          (0, _utils.logErr)((_response$data2 = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9]]);
  })();
}
function resourcesWatcher() {
  return _regenerator["default"].wrap(function resourcesWatcher$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables.LOAD_PHONE_REGIONS_REQUEST, listPhonesRegions)]);
      case 2:
      case "end":
        return _context2.stop();
    }
  }, _marked);
}